import React, {useState, useRef, useEffect} from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import {Modal} from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux';
import {CardGridActions} from '../../actions/CardGridAction'
import {CardDetailActions} from '../../actions/CardDetailAction'
import * as Yup from 'yup'


const AddCard = (props) => {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState('ui form')
    const dispatch = useDispatch();
    const cardData = useSelector(state => state.cardGrid)

    const FILE_SIZE = 5000 * 1024; //5MB
    const SUPPORTED_FORMATS = [
      "image/jpg",
      "image/jpeg",
      "image/gif",
      "image/png"
    ];
    const formikRef = useRef();
    const fileInput = React.createRef()

    const onAddCardSubmit = (values) => {
        setOpen(false)
        if ((props && props.mode === 'edit')) {
            dispatch(CardGridActions.updateCard(props.card, values))
        }
        else {
            dispatch(CardGridActions.addCard(values))
        }
    }
    const onPlayerSearch = (values) => {
        if (values.setName && values.cardNum && values.year) {
            dispatch(CardDetailActions.getPlayerName(values))
        }
    }
    useEffect(() => {  //Set Formik state with actual name
        if (formikRef.current) {
            formikRef.current.setFieldValue("player", cardData.currPlayerName)
        }
      }, [cardData.currPlayerName]);
      

      useEffect(() => {  //whenever a image is uploaded, fill in whatever we can...
        if (formikRef.current && cardData.currAddVals) {
            if (cardData.currAddVals.cardNum) {
                formikRef.current.setFieldValue("cardNum", cardData.currAddVals.cardNum)
            }
            if (cardData.currAddVals.company) {
                formikRef.current.setFieldValue("graded", cardData.currAddVals.company)
            }
            if (cardData.currAddVals.gradeVal) {
                formikRef.current.setFieldValue("condition", cardData.currAddVals.gradeVal)
            }
            if (cardData.currAddVals.setName && cardData.currAddVals.setYear) {
                formikRef.current.setFieldValue("setName", cardData.currAddVals.setYear + ' ' + cardData.currAddVals.setName)
            }
            if (cardData.currAddVals.setYear) {
                formikRef.current.setFieldValue("year", cardData.currAddVals.setYear)
            }
            if (cardData.currAddVals.qualifier) {
                formikRef.current.setFieldValue("qualifier", cardData.currAddVals.qualifier)
            }
            if (cardData.currAddVals.setYear && cardData.currAddVals.setName && cardData.currAddVals.cardNum) {
                let values = {
                    cardNum: cardData.currAddVals.cardNum,
                    year: cardData.currAddVals.setYear,
                    setName: cardData.currAddVals.setName
                }
                onPlayerSearch(values)
            }
        }
        setLoading('ui form')
        // eslint-disable-next-line
      }, [cardData.currAddVals ]);

    
    const renderTriggerButton = () => {
        
        if (props && props.mode === 'edit') {
            return <i className="edit outline icon"></i>
        }
        else {
            return <button className="ui inverted green button">Add Card</button>
        }
    }

    const onImageChange = (event) => {
        formikRef.current.setFieldValue("imageUrl", event.currentTarget.files[0]);
        dispatch(CardDetailActions.getDetailsFromImage(event.currentTarget.files[0]))
        setLoading('ui form loading')
    }

    return (
        <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        trigger={renderTriggerButton()}
        >
            
            <Modal.Header>{ props && props.mode === 'edit'? 'Edit Card' : 'Add a Card'}</Modal.Header>
            <Modal.Content className={loading}>
                <Formik
                        innerRef={formikRef}
                        initialValues={{
                            imageUrl: props.card ? props.card.imageUrl : '',
                            year: props.card ? props.card.year : '',
                            setName: props.card ? props.card.setName :'Topps',
                            player:  props.card ? props.card.player : '',
                            cardNum: props.card ? props.card.cardNum : 0,
                            condition: props.card ? props.card.condition :'',
                            graded: props.card ? props.card.graded :'RAW',
                            qualifier: props.card ? props.card.qualifier :'None',
                            autograph: props.card ? props.card.autograph :false,
                            gameUsed: props.card ? props.card.gameUsed :false,
                            serialNumber: props.card ? props.card.serialNumber :'',
                            price: props.card ? props.card.price :0,
                            sold: props.card ? props.card.sold :false,
                            completeSetId: props.card  &&  props.card.completeSetId &&  props.card.completeSetId !== 'false' ? props.card.completeSetId : null,
                            soldPrice: props.card ? props.card.soldPrice :0
                        }}
                        validationSchema={Yup.object().shape({
                            imageUrl: Yup.mixed()
                            .required("An Image is required")
                            .test(
                              "fileSize",
                              "Image too large",
                              value => (value && value.size <= FILE_SIZE) || (value && !value.size)
                            )
                            .test(
                              "fileFormat",
                              "Unsupported Format",
                              value => (value && SUPPORTED_FORMATS.includes(value.type)) || (value && !value.type)
                            ),
                            year: Yup.number()
                                .required('Year is required'),
                            setName: Yup.string()
                                .required('Set Name is required'),
                            player: Yup.string()
                                .required('Player is required'),
                            cardNum: Yup.string()
                                .required('Player is required')
                        })}
                            onSubmit={ values => {onAddCardSubmit(values)}}
                        >
                        {({ values }) => (
                            
                            <Form className="ui form"> 
                                <h4 className="ui dividing header">Add Card</h4>
                                
                                 <input ref={fileInput} id="imageUrl" name="imageUrl" style={{display: "none"}} type="file" onChange={(event) => {onImageChange(event)}} />
                                 <button className="ui blue basic button" type="button" onClick={() => fileInput.current.click()}>
                                    <i className="file icon"></i>
                                    Choose file
                                 </button>
                                 <small>
                                        {values.imageUrl ? values.imageUrl.name || values.imageUrl : "No file chosen"}
                                </small>
                                <ErrorMessage name="imageUrl" component="h5" className="ui red header" />
                                <div className="four fields">

                                    <div className="field">
                                        <label>Year</label>
                                        <Field id="year" name="year" placeholder="" />
                                        <ErrorMessage name="year" component="h5" className="ui red header" />
                                    </div>
                                    <div className="field">
                                        <label>Set Name</label>
                                        <Field  as="select" className="field" id="setName" name="setName" placeholder="" >
                                        <option value="All">All</option> 
                                        {cardData.setList.map(setItem =>
                                        <option key={setItem.setName} value={setItem.setName}>{setItem.setName}</option>
                                         )};
                                        </Field>
                                        <ErrorMessage name="setName" component="h5" className="ui red header" />
                                    </div>
                                    <div className="field">
                                        <label>Card Number</label>
                                        <Field className="field" id="cardNum" name="cardNum" placeholder="0" />
                                        <ErrorMessage name="cardNum" component="h5" className="ui red header" />
                                    </div>
                                    <div className="field">
                                    <label> </label>
                                     <button className="ui green basic button" type="button" onClick={() => onPlayerSearch(values)}>Get Player Name</button>
                                    </div>
                                </div>
                                <div className="field">
                                    <label>Player</label> 
                                    <Field className="field" id="player" name="player" placeholder=""/>
                                    <ErrorMessage name="player" component="h5" className="ui red header" />
                                </div>
                                    
                                <div className="three fields">
                                    <div className="field">
                                        <label>Condition</label>
                                        <Field as="select" className="field" id="condition" name="condition" placeholder="0" >
                                            <option value="0">N/A</option>
                                            <option value="1">Poor</option>
                                            <option value="1.5">Fair</option>
                                            <option value="2">Good</option>
                                            <option value="2.5">Good+</option>
                                            <option value="3">Very Good</option>
                                            <option value="3.5">Very Good+</option>
                                            <option value="4">VG/EX</option>
                                            <option value="4.5">VG/EX+</option>
                                            <option value="5">Excellent</option>
                                            <option value="5.5">Excellent+</option>
                                            <option value="6">EX-MT</option>
                                            <option value="6.5">EX-MT+</option>
                                            <option value="7">Near Mint</option>
                                            <option value="7.5">Near Mint+</option>
                                            <option value="8">NM-MT</option>
                                            <option value="8.5">NM-MT+</option>
                                            <option value="9">Mint</option>
                                            <option value="9.5">Gem Mint</option>
                                            <option value="10">Pristine</option>
                                        </Field>
                                    </div>
                                    <div className="field">
                                        <label>Graded</label>
                                        <Field as="select" className="graded" id="graded" name="graded" placeholder="RAW" >
                                            <option value="RAW">Raw</option>
                                            <option value="PSA">PSA</option>
                                            <option value="SGC">SGC</option>
                                            <option value="BGS">BGS</option>
                                            <option value="BVG">BVG</option>
                                            <option value="OTH">Other</option>
                                        </Field>
                                    </div>
                                    <div className="field">
                                        <label>Qualifiers</label>
                                        <Field as="select" className="qualifier" id="qualifier" name="qualifier" placeholder="None" >
                                            <option value="None">None</option>
                                            <option value="MK">Mark</option>
                                            <option value="OC">Off-Center</option>
                                            <option value="MC">Miscut</option>
                                            <option value="PD">Print Defect</option>
                                            <option value="OF">Out of Focus</option>
                                            <option value="ALTERED">Altered</option>
                                            <option value="ST">Stain</option>
                                        </Field>
                                    </div>    
                                </div>
                                <div className="four fields">
                                    <div className="field">
                                        <label>Autographed</label>
                                        <Field type="checkbox" className="field" id="autograph" name="autograph" placeholder="" />
                                    </div>
                                    <div className="field">
                                        <label>Game Used</label>
                                        <Field type="checkbox" className="field" id="gameUsed" name="gameUsed" placeholder="" />
                                    </div>
                                    <div className="field">
                                        <label>Serial Number</label>
                                        <Field className="field" id="serialNumber" name="serialNumber" placeholder="" />
                                    </div>
                                    <div className="field">
                                        <label>Price</label>
                                        <Field className="field" id="price" name="price" placeholder="" />
                                    </div>
                                </div>

                                <div className="three fields">
                                    <div className="field">
                                    <label>Part of Complete Set?</label>
                                        <Field className="field" id="completeSetId" name="completeSetId" placeholder="false" />
                                    </div>
                                    <div className="field">
                                        <label>Sold</label>
                                        <Field type="checkbox" className="field" id="sold" name="sold" placeholder="" />
                                    </div>
                                    <div className="field">
                                    <label>Sale Price</label>
                                        <Field className="field" id="soldPrice" name="soldPrice" placeholder="" />
                                    </div>
                                </div>

                                <button className="ui basic blue button" type="submit">{props && props.mode === 'edit'? 'Update' : 'Add Card'}</button>
                            </Form>
                        )}
                </Formik>
            </Modal.Content>

        </Modal>
    )

}
export default AddCard